import React from 'react';
import RegisterLayout from '../components/registrationLayout/registrationAndLoginLayout';

const Auth = () => {
  return <RegisterLayout />;
};

export default Auth;
